import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpContextToken,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, finalize } from 'rxjs';

import { SpinnerService } from './spinner.service';

export const USE_GLOBAL_SPINNER = new HttpContextToken<boolean>(() => false);

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  private spinner = inject(SpinnerService);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const url = request.urlWithParams;

    if (request.context.get(USE_GLOBAL_SPINNER)) {
      this.spinner.startLoading(url);
    }

    return next
      .handle(request)
      .pipe(finalize(() => this.spinner.stopLoading(url)));
  }
}
